import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PTL_BASE_PATH, PTL_LEGACY_BASE_PATH } from './constants';

/**
 * Old links keep working. With `to`: the page moved there (filters in the query string are kept). Without: an old
 * /ptl-visibility/... link (from before the rename) opens the same page under /ptl-delivery-health/...
 */
export default function LegacyPathRedirect({ to }) {
  const { pathname, search } = useLocation();
  return <Navigate replace to={`${to || pathname.replace(PTL_LEGACY_BASE_PATH, PTL_BASE_PATH)}${search}`} />;
}
